module.exports = __webpack_public_path__ + "img/Icon metro-security.ea3b9ac0.svg";